import { FF, TOTAL_COMPANY } from '@publishing/helpers';
import type { SvgIconValue } from '@publishing/components/ui/Icon';
import {
  ProductsSharedOffice, ProductsPrivateOffice, ProductsCustomOffice, ProductsOfficeLease,
  ProductsOfficeInterior, ProductsOfficeSolution, ProductsIndividualOffice, ProductsLoungeMembership,
  ProductsSpaceRental, ProductsItDiscount, ProductsBuildingSolution,
} from '@publishing/components/ui/SvgSprite';

// 비디오 컨트롤
 export const TIMELINE = [
  { start: 0,    end: 9.30, text: '' },
  { start: 9.30, end: 15.30, text: '공유오피스' },
  { start: 15.30, end: 21.30, text: '전용오피스' },
  { start: 21.30, end: 27.30, text: '맞춤형오피스' },
  { start: 27.30, end: 33.30, text: '사무실 인테리어' },
  { start: 33.30, end: 39.30, text: '라운지 멤버십' },
];

// 오피스 카드
export type ProductItem = {
  iconName: SvgIconValue;
  href: string;
  text: string;
  title: string;
  target?: '_self' | '_blank';
};

export type ProductGroup = {
  label: string;
  items: ProductItem[];
};

export const PRODUCT_GROUPS: ProductGroup[] = [
  {
    label: '오피스 공간',
    items: [
      { iconName: ProductsSharedOffice,  href: '/shared-office', text: '대한민국 사무실의 기준',  title: '공유오피스'   },
      { iconName: ProductsPrivateOffice, href: '/private-office', text: '한 층을 프라이빗하게',    title: '전용오피스'   },
      { iconName: ProductsCustomOffice,  href: '/custom-office', text: '유연한 커스터마이징',     title: '맞춤형오피스' },
      { iconName: ProductsOfficeLease,    href: '/office-lease', text: '중개 수수료 0원',        title: '임대오피스'  },
    ],
  },
  {
    label: '사무실 구축',
    items: [
      { iconName: ProductsOfficeSolution, href: '/office-solution', text: '부지 선정부터 시설 관리까지', title: '사옥 구축 솔루션' },
      { iconName: ProductsOfficeInterior,   href: '/office-interior', text: '업계 1위 오피스 디자인',     title: '사무실 인테리어'  },
    ],
  },
  {
    label: '1인 전용 상품',
    items: [
      { iconName: ProductsLoungeMembership, href: '/lounge-membership', text: `전국 ${FF.SPOT_TOTAL}개 몰입 공간`, title: '라운지 멤버십' },
      { iconName: ProductsIndividualOffice,       href: '/individual-office', text: '오늘 계약, 내일 입주',  title: '1인 오피스'   },
    ],
  },
  {
    label: '비즈니스 솔루션',
    items: [
      { iconName: ProductsSpaceRental, href: 'https://open-space.fastfive.co.kr/', text: '미팅룸·세미나룸', title: '공간 대여 예약', target: '_blank' },
      { iconName: ProductsItDiscount, href: 'https://fivecloud.co.kr/?utm_source=fastfive.co.kr&utm_medium=referral&utm_campaign=mainsection', text: '소프트웨어·클라우드', title: '기업 IT 할인', target: '_blank' },
      { iconName: ProductsBuildingSolution, href: 'https://buildingsolution.co.kr/?utm_source=fastfive.co.kr&utm_medium=referral&utm_campaign=mainsection', text: '중소형 빌딩 올인원 솔루션', title: '빌딩 솔루션', target: '_blank' },
    ],
  }
];

// 수치 슬롯 섹션
type StatItem = {
  label: string;
  countValue: number;
  suffix: string;
  startValue: number;
};

/** 통계 숫자 표시: 정수는 천 단위 콤마, 소수는 실제 자릿수 유지 */
export function formatStatNumber(n: number): string {
  if (!Number.isFinite(n)) return String(n);
  if (Number.isInteger(n)) {
    return n.toLocaleString('ko-KR');
  }
  const decimals = String(n).split('.')[1]?.length ?? 0;
  return n.toLocaleString('ko-KR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
export const STATS: StatItem[] = [
  { label: '오피스 브랜드 인지도', countValue: 1, suffix: '위', startValue: 37 },
  { label: '공유오피스 지점 수',   countValue: FF.BRANCH, suffix: '개', startValue: 0, },
  { label: '공유오피스 누적 고객사 수', countValue: TOTAL_COMPANY, suffix: '개', startValue: 16857, },
  { label: '공유오피스 만족도',    countValue: Number(FF.RATING), suffix: '점', startValue: 0,  },
  { label: '보유 임대 사무실 매물',  countValue: 4595, suffix: '개', startValue: 0,  },
  { label: '사옥 구축·인테리어 고객사 수',  countValue: 148, suffix: '개', startValue: 0,  },
];